<template>
  <div class="pvc-tree-node">
    <div class="item-rect" :class="{opened: isOpened, green: isLeaf }" @click="itemClick()" v-if="!isLeaf">
      <span class="chevron d-inline-block mr-3" :class="{opened: isOpened}">
        <i v-if="isOpened" class="fas fa-chevron-down"></i>
        <i v-if="!isOpened" class="fas fa-chevron-right"></i>
      </span>
      <p class="d-inline-block mb-0">{{ data.name }}</p>
    </div>
    <div class="children pl-5" v-if="hasChildren" v-show="isOpened">
      <applications-tree-node
        v-for="child in data.children"
        :key="child.id"
        :data="child"
        :max="max"
        :remaining="remaining"
        :sliderStatusId="sliderStatusId"
        :sumInSliders="sumInSliders"
        :inPercentage="inPercentage"
      ></applications-tree-node>
    </div>
    <div class="item-rect d-flex" :class="{green: isLeaf }" @click="itemClick()" v-if="isLeaf">
      <div class="flex-grow-1 text-right">
        <div class="d-flex text-left align-items-center">
          <div class="mr-2">
            {{ data.name }}
          </div>
          <div class="ml-auto mr-2 d-flex align-items-center">
            <div style="width: 95px;" class="mr-2">
              <application-tree-node-input
                :value="inputValue"
                :inPercentage="inPercentage"
                :remaining="remaining"
                :handleValueChange="handleOnTreeNodeInputChange"
              />
              <!-- <input
                :class="{'color-green': areValuesOk}"
                class="form-control simple text-right"
                v-model="inputValue"
                :disabled="isSliderDisabled"
              /> -->
            </div>
            <span class="d-inline-block mr-3">{{getWeightUnit}}</span>
          </div>
          <div class="mr-4 d-flex align-items-center">
            <div class="flex-grow-1">
              <vue-slider
                ref="slider"
                style="width: 400px;"
                v-model="volume"
                :max="max"
                :disabled="isSliderDisabled"
                :tooltip="'none'"
                :silent="true"
                @drag-end="onDragEnd"
              ></vue-slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _throttle from 'lodash/throttle';
  import ApplicationTreeNodeInput from './ApplicationTreeNodeInput';

  export default {
    name: 'ApplicationsTreeNode',
    props: {
      data: {
        type: Object,
        default: () => {}
      },
      max: {
        type: Number,
        default: 0
      },
      remaining: {
        type: Number,
        default: 0
      },
      sliderStatusId: {
        type: Number,
        default: 0
      },
      sumInSliders: {
        type: Number,
        default: 0
      },
      inPercentage: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isOpened: true,
        inputValue: 0,
      };
    },

    computed: {
      getWeightUnit() {
        if (this.inPercentage === true) {
          return '%';
        }
        return this.$store.getters['user/getWeightUnit'];
      },
      isSliderDisabled() {
        if (this.sliderStatusId === -1) {
          return true;
        }
        return this.sliderStatusId === this.data.id;
      },
      id () {
        return 'base-applications-tree-' + this._uid;
      },
      hasChildren () {
        return this.data.children && this.data.children.length > 0;
      },
      isLeaf () {
        return !this.hasChildren;
      },
      materials () {
        return this.$store.getters['materials/materials'];
      },
      applications () {
        return this.$store.getters['applications/getApplications'];
      },
      volume: {
        get () {
          const t = this.$store.getters['userApplications/current'];
          if (typeof t.applications === 'undefined') {
            return 0;
          }
          const item = t.applications.filter(e => e.id === this.data.id);

          if (item.length > 0) {
            return item[0].volume;
          }
          return 0;
        },
        set (value) {
          this.$store.dispatch('userApplications/setPercentage', {id: this.data.id, volume: value});
          this.setCorrectMaxPosibleValue();
        }
      },
      areValuesOk () {
        const t = this.$store.getters['userApplications/current'];
        let sum = 0;
        if (typeof t.applications !== 'undefined') {
          t.applications.forEach(e => {
            sum += e.volume;
          });
        }
        return sum <= this.remaining && sum > 0;
      }
    },

    watch: {
      volume(newValue) {
        this.inputValue = this.volumeByWeightUnit(newValue);
      },
      inputValue(newValue) {
        const value = newValue || 0;
        const valueNumber = parseInt(value, 0);

        this.volume = Math.abs(valueNumber);
      },
    },

    methods: {
      handleOnTreeNodeInputChange(newValue) {
        this.inputValue = newValue;
      },
      onDragEnd() {
        this.$refs.slider.setValue(this.volume);
      },
      setCorrectMaxPosibleValue: _throttle(function() {
          // setTimeout(() => {
            if (this.sumInSliders > this.remaining) {
              const newValue = this.volume - (this.sumInSliders - this.remaining);
              this.$store.dispatch('userApplications/setPercentage', {id: this.data.id, volume: newValue});
            }
          // }, 0);
      }, 500),
      itemClick () {
        this.isOpened = !this.isOpened;
      },
      volumeByWeightUnit(volume) {
        if (this.getWeightUnit === 'ton') {
          return volume / 1000;
        }
        return volume;
      },
    },
    components: {
      'application-tree-node-input': ApplicationTreeNodeInput,
    }
  };

</script>

<style>

</style>
